/**
 * @property {Voter[]} voters
 */
export class Voters {
    constructor() {
        this.voters = [];
    }

    /**
     * @param {Voter} voter
     */
    addVoter(voter) {
        this.voters.push(voter);
    }

    /**
     * @param {AccessPermissionRequest} request
     * @returns {boolean}
     */
    vote(request) {
        for (const voter of this.voters) {
            if (!voter.supports(request)) {
                continue;
            }

            const granted = voter.vote(request);

            if (granted !== undefined) {
                return granted;
            }
        }

        return true;
    }
}
